import React, { createContext, FC, useMemo, useState, useCallback, useEffect, ReactNode } from 'react';
import { ToastData, ToastProviderValues } from './types';

export const ToastContext = createContext<ToastProviderValues>({
  toasts: [],
} as ToastProviderValues);

export const ToastProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [toasts, setToasts] = useState<ToastData[]>([]);
  const [expiredToasts, setExpiredToasts] = useState<number[]>([]);

  const removeToast = useCallback(
    (id: number) => {
      setExpiredToasts((prev) => [...prev, id]);
    },
    [expiredToasts],
  );

  const addToast = useCallback(
    (unregisteredToast: ToastData) => {
      const id = Math.random();
      const toast = { ...unregisteredToast, id };
      setToasts((prev) => [...prev, toast]);
      return id;
    },
    [toasts],
  );

  const value = useMemo(
    () => ({
      toasts,
      addToast,
      removeToast,
    }),
    [toasts, addToast, removeToast],
  );

  useEffect(() => {
    if (expiredToasts.length) {
      setToasts((prev) => prev.filter((toast) => !expiredToasts.includes(toast.id)));
      setExpiredToasts([]);
    }
  }, [expiredToasts]);

  return <ToastContext.Provider value={value}>{children}</ToastContext.Provider>;
};
